import { useTranslation } from "react-i18next"
import Inner from "../../components/Inner"
import { infoEmail } from "../../config"

export default function Contact() {
    const { t } = useTranslation()
    return (
        <Inner>
            <div className="py-16 px-4 max-w-2xl mx-auto">
                <h1 className="text-3xl font-bold mb-6">{t("Contact")}</h1>
                <p className="mb-4">{t("For any inquiries, please email us at")} <a href={`mailto:${infoEmail}`} className="underline">{infoEmail}</a></p>
            </div>
        </Inner>
    )
}
